import { Component } from '@angular/core';
import { ListTableComponent } from '../../../../shared/components/list-table/list-table.component';
import { ParticipantLeadsListComponent } from '../../../participant-leads-list/participant-leads-list.component';
import { BillingFilterComponent } from '../../billing-filter/billing-filter.component';

@Component({
  selector: 'ppl-claims-list',
  standalone: true,
  imports: [ListTableComponent, BillingFilterComponent],
  templateUrl: './claims-list.component.html',
  styleUrl: './claims-list.component.css',
})
export class ClaimsListComponent extends ParticipantLeadsListComponent {
  showTable = false;
  fields = [
    { field: 'Timeframe', show: true, default: '30 days' },
    { field: 'status', show: true },
    { field: 'batchId', show: true },
    { field: 'fileName', show: true },
    { field: 'consumerPplId', show: true },
    { field: 'mcoId', show: true },
    { field: 'medicaidId', show: true },
    { field: 'serviceDate', show: true },
    { field: 'payerName', show: true },
    { field: 'pmpm', show: true },
  ];

  onSearch(event: any) {
    console.log('EVent----', event);
    this.showTable = true;
  }
}
